import { render } from "./SimulatorControls.vue?vue&type=template&id=a0adf8f0&scoped=true"
import script from "./SimulatorControls.vue?vue&type=script&lang=js"
export * from "./SimulatorControls.vue?vue&type=script&lang=js"

import "./SimulatorControls.vue?vue&type=style&index=0&id=a0adf8f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0adf8f0"]])

export default __exports__